<template>
  <div>
    <div class="mr-b30">
      <el-row type="flex" class="title-bar vertical-center-box" style="height:28px">
        <div class="title-h4">알람 수신 설정</div>
        <div v-if="isAlarmLock">
          <el-button @click="releaseAlarmLock" class="mr-l8
          ">잠금 해제</el-button>
          <span class="mr-l4" style="color:#476fd5">단문 메시지가 잠금 상태입니다. 알람을 받기 위해서 [잠금]을 해제해주세요.</span>
        </div>
      </el-row>
      <el-row class="gray-box vertical-center-box" type="flex">
        <el-checkbox-group v-model="alarmType">
          <el-checkbox v-for="item in alarmTypeList" :key="item.alarmtypeId" :label="item.alarmtypeId">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </el-row>
    </div>
    <div class="mr-b30">
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="title-h4">요일별 알람설정</div>
        <el-button type="primary" @click="rejectRuleDayTime">정책 설정 복원</el-button>
      </el-row>
      <el-table :data="weekTimeData" width="100%" @cell-click="clickWeekDay">
        <el-table-column prop="day" label="요일" width="80" header-align="center" fixed>
          <template slot-scope="scope">
            <span class="el-icon-check c-pointer"> {{ scope.row.day }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="i in 24" :key="i" :prop="'h' + (i-1)" :label="(i-1)+'시'" width="80" header-align="center" align="center" :render-header="renderTimeHeader">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row['h'+(i-1)]"></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="title-h4">공휴일 알람설정</div>
        <el-button type="primary" @click="rejectRuleDateTime">정책 설정 복원</el-button>
      </el-row>
      <el-table :data="dateTimeData" width="100%" @cell-click="clickDate">
        <el-table-column prop="dateId" label="날짜" width="120" header-align="center" fixed>
          <template slot-scope="scope">
            <span class="el-icon-check c-pointer"> {{getDateToString( scope.row.dateId, 'YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dateName" label="내용" width="120" header-align="center" fixed></el-table-column>
        <el-table-column v-for="i in 24" :key="i" :prop="'h' + (i-1)" :label="(i-1)+'시'" width="80" header-align="center" align="center" :render-header="renderDateHeader">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row['h'+(i-1)]"></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import userApi from '@/api/frame/user';
import { getDateToString } from '@/utils/date';
import MsgUtil from '@/utils/message';

const CHECK_FLAG = false;
export default {
  name: 'WEventAlarmSettingView',
  props: {
    isAlarmLock: {
      type: Boolean,
      default: false,
    },
    activeSubTab: {
      type: String,
    },
  },
  data() {
    return {
      originAlarmType: [],
      originWeekTimeData: [],
      originDateTimeData: [],
      alarmTypeList: [
        { alarmtypeId: 'SMS', label: '단문메시지' },
        { alarmtypeId: 'EMAIL', label: '이메일' },
      ],
      alarmType: [],
      weekTimeData: [],
      dateTimeData: [],
      weekCheckFlag: {},
      dateCheckFlag: {},
    };
  },
  watch: {
    activeSubTab(activeSubTab) {
      if (activeSubTab === 'eventAlarm') {
        this.loadData();
      }
    },
  },
  methods: {
    getDateToString,
    /**
     * 전체 데이터 로드
     * @author kimjy
     */
    loadData() {
      this.loadRuleMgrAlarmType();
      this.loadMgrWeekdayTimeList();
      this.loadMgrDateTimeList();
    },
    /**
     * 알람방식 로드
     * @author kimjy
     */
    loadRuleMgrAlarmType() {
      userApi.getRuleMgrAlarmType().then((response) => {
        this.alarmType = [];
        if (response.data.success) {
          forEach(response.data.data, (item) => {
            this.alarmType.push(item.alarmtypeId);
          });
          this.originAlarmType = cloneDeep(this.alarmType);
        }
      });
    },
    /**
     * 요일별 알람설정 로드
     * @author kimjy
     */
    loadMgrWeekdayTimeList() {
      userApi.getMgrWeekdayTimeList().then((response) => {
        if (response.data.success) {
          this.weekTimeData = response.data.data;
          this.originWeekTimeData = cloneDeep(this.weekTimeData);
          forEach(this.weekTimeData, (item) => {
            this.weekCheckFlag[item.weekdayId] = CHECK_FLAG;
          });
        }
      });
    },
    /**
     * 공휴일 알람설정 로드
     * @author kimjy
     */
    loadMgrDateTimeList() {
      userApi.getMgrDateTimeList().then((response) => {
        if (response.data.success) {
          this.dateTimeData = response.data.data;
          this.originDateTimeData = cloneDeep(this.dateTimeData);
          forEach(this.dateTimeData, (item) => {
            this.dateCheckFlag[item.dateId] = CHECK_FLAG;
          });
        }
      });
    },
    /**
     * 요일별 알람설정 테이블 헤더 가공
     * @author kimjy
     */
    renderTimeHeader(h, { column }) {
      const func = this.headerClick;
      const tempHeader = h(
        'span',
        {
          class: 'el-icon-check c-pointer',
          checkFlag: CHECK_FLAG,
          style: {
            width: '100%',
          },
          domProps: {
            innerHTML: column.label,
          },
          on: {
            click() {
              func(tempHeader, column, 'week');
            },
          },
        },
      );
      return tempHeader;
    },
    /**
     * 공휴일 알람설정 테이블 헤더 가공
     * @author kimjy
     */
    renderDateHeader(h, { column }) {
      const func = this.headerClick;
      const tempHeader = h(
        'span',
        {
          class: 'el-icon-check c-pointer',
          style: {
            width: '100%',
          },
          checkFlag: CHECK_FLAG,
          domProps: {
            innerHTML: column.label,
          },
          on: {
            click() {
              func(tempHeader, column, 'date');
            },
          },
        },
      );
      return tempHeader;
    },
    /**
     * 컬럼 헤더 클릭 이벤트 (클릭 시 체크박스 전체 체크/해제 동작)
     * @author kimjy
     */
    headerClick(tempHeader, column, type) {
      const key = column.property;
      tempHeader.data.checkFalg = !tempHeader.data.checkFalg;
      forEach(this[`${type}TimeData`], (item) => {
        item[key] = tempHeader.data.checkFalg;
      });
    },
    /**
     * 요일 클릭 (클릭 시 체크박스 전체 체크/해제 동작)
     * @author kimjy
     */
    clickWeekDay(row, column) {
      if (column.property === 'day') {
        this.weekCheckFlag[row.weekdayId] = !this.weekCheckFlag[row.weekdayId];
        forEach(row, (value, key) => {
          if (key.indexOf('h') >= 0) {
            row[key] = this.weekCheckFlag[row.weekdayId];
          }
        });
      }
    },
    /**
     * 날짜 클릭 (클릭 시 체크박스 전체 체크/해제 동작)
     * @author kimjy
     */
    clickDate(row, column) {
      if (column.property === 'dateId') {
        this.dateCheckFlag[row.dateId] = !this.dateCheckFlag[row.dateId];
        forEach(row, (value, key) => {
          if (key.indexOf('h') >= 0) {
            row[key] = this.dateCheckFlag[row.dateId];
          }
        });
      }
    },
    /**
     * 알람 시간 설정 : 요일별 정책 설정 복원
     * @author kimjy
     */
    rejectRuleDayTime() {
      userApi.rejectRuleDayTime().then((response) => {
        if (response.data.success) {
          this.loadMgrWeekdayTimeList();
        }
      });
    },
    /**
     * 알람 시간 설정 : 공휴일 정책 설정 복원
     * @author kimjy
     */
    rejectRuleDateTime() {
      userApi.rejectRuleDateTime().then((response) => {
        if (response.data.success) {
          this.loadMgrDateTimeList();
        }
      });
    },
    // /**
    //  * 변경 내용 취소
    //  * @author kimjy
    //  */
    // cancelAlarmData() {
    //   this.$emit('onCancelPopup');
    //   // this.alarmType = cloneDeep(this.originAlarmType);
    //   // this.weekTimeData = cloneDeep(this.originWeekTimeData);
    //   // this.dateTimeData = cloneDeep(this.originDateTimeData);
    // },
    /**
     * 변경 내용 저장
     * @author kimjy
     */
    setAlarmData() {
      const params = {};

      // 각 컨텐츠의 내용이 변경됐는지 확인하기 위한 플래그 (정보 수정 후 데이터 리로드시 사용)
      let alarmTypeFlag = false;
      let weekTimeFlag = false;
      let dateTimeFlag = false;

      // 알람 방식 설정 (변경된 내용이 있을 경우)
      if (!isEqual(this.originAlarmType, this.alarmType)) {
        const alarmTypeParam = [];
        forEach(this.alarmTypeList, (item) => {
          const originIndex = this.originAlarmType.indexOf(item.alarmtypeId);
          const dataIndex = this.alarmType.indexOf(item.alarmtypeId);
          // origin 데이터에 존재하고, 현재 설정된 데이터에 없을 경우 삭제되었다고 판단
          // origin 데이터에 존재하지 않고, 현재 설정된 데이터에 있을 경우 추가 설정되었다고 판단
          if (originIndex >= 0 && dataIndex < 0) {
            alarmTypeParam.push({
              alarmtypeId: item.alarmtypeId,
              check_flag: false,
            });
          } else if (originIndex < 0 && dataIndex >= 0) {
            alarmTypeParam.push({
              alarmtypeId: item.alarmtypeId,
              check_flag: true,
            });
          }
        });
        alarmTypeFlag = true;
        params.alarmtypeList = alarmTypeParam;
      }

      // 요일별 알람 시간 설정 (변경된 내용이 있을 경우)
      const weekTime = differenceWith(this.weekTimeData, this.originWeekTimeData, isEqual); // 변경된 데이터(row) 추출
      if (weekTime.length > 0) {
        const weekTimeData = [];
        forEach(weekTime, (item) => {
          const originData = find(this.originWeekTimeData, ['weekdayId', item.weekdayId]);
          forEach(item, (value, key) => { // key: weekdayId, h0, h2 ...
            if (key.indexOf('h') >= 0 && originData[key] !== value) {
              weekTimeData.push({
                weekdayId: item.weekdayId,
                ruleTypeId: item.ruleTypeId,
                hourId: Number(key.substring(1)),
                applyFlag: value ? 'Y' : 'N',
              });
            }
          });
        });
        weekTimeFlag = true;
        params.ruleTimeList = weekTimeData;
      }

      // 날짜별 알람 시간 설정 (변경된 내용이 있을 경우)
      const dateTime = differenceWith(this.dateTimeData, this.originDateTimeData, isEqual); // 변경된 데이터(row) 추출
      if (dateTime.length > 0) {
        const dateTimeData = [];
        forEach(dateTime, (item) => {
          const originData = find(this.originDateTimeData, ['dateId', item.dateId]);
          forEach(item, (value, key) => { // key: dateId, h0, h2 ...
            // 데이터가 변경된 시간만 추출하여 배열에 추가
            if (key.indexOf('h') >= 0 && originData[key] !== value) {
              dateTimeData.push({
                dateId: item.dateId,
                ruleTypeId: item.ruleTypeId,
                hourId: Number(key.substring(1)),
                applyFlag: value ? 'Y' : 'N',
              });
            }
          });
        });
        dateTimeFlag = true;
        params.ruleDateList = dateTimeData;
      }

      // 데이터 수정
      userApi.updateRuleMgr(params).then((response) => {
        if (response.data.success) {
          this.$message('알람 설정이 완료되었습니다.');
          // 변경된 내용이 있는 컨텐츠의 경우에만 로드
          if (alarmTypeFlag) {
            this.loadRuleMgrAlarmType();
          }
          if (weekTimeFlag) {
            this.loadMgrWeekdayTimeList();
          }
          if (dateTimeFlag) {
            this.loadMgrDateTimeList();
          }
        }
      });
    },
    releaseAlarmLock() {
      this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.RELEASE)).then(() => {
        userApi.resetAlarmLockCount().then((response) => {
          const result = response.data;
          if (result.success) {
            this.$emit('release-alarm-lock');
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.RELEASE, '알람 잠금', true));
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.RELEASE, '알람 잠금', false));
          }
        });
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/frame/components/popup/EventAlarmSettingView.vue